<template>
    <div class="card"
         style="margin-top: 10px; padding-bottom: 10px">
        <div class="title">{{$t('我的云产品')}}</div>
        <ul class="product-pack">
            <li class="orange"
                v-if="products.ModelAtrs.services && products.ModelAtrs.services.length">
                <div class="tit">{{$t('EI企业智能')}}</div>
                <ul>
                    <li v-for="(item, k) in products.ModelAtrs.services"
                        :key="`co${k}`">
                        <span class="rc-ellipsis"
                              :title="item.serviceName">{{$t(item.serviceName)}}</span>
                        <b>{{item.quantity}}</b>
                    </li>
                </ul>
            </li>
            <li class="pink"
                v-if="products.computes.services && products.computes.services.length">
                <div class="tit">{{$t('计算')}}</div>
                <ul>
                    <li v-for="(item, k) in products.computes.services"
                        :key="`st${k}`"
                        v-if="item.serviceType!='HPC'||((item.serviceType=='HPC'||item.serviceType==='HPC-SAAS')&&productTypeList.indexOf(item.serviceType)!==-1)">
                        <span class="rc-ellipsis"
                              :title="item.serviceName">{{$t(item.serviceName)}}</span>
                        <b>{{item.quantity}}</b>
                    </li>
                </ul>
            </li>
        </ul>
        <template v-if="products.others.length">
            <div class="title">{{$t('网络及其他资源')}}</div>
            <ul class="resource-pack"
                :style="{height: (products.others.length > 4 && showAll) ? '280px' : '150px'}">
                <li v-for="(item, k) in products.others"
                    :key="`nw${k}`">
                    <div class="sub-pack">
                        <p class="title">{{$t(item.catalogName)}}</p>
                        <div v-for="subItem in item.services"
                             :key="subItem.id"
                             class="sub-container">
                            <!-- <i :class="item.icon"></i> -->
                            <span class="rc-ellipsis"
                                  :title="subItem.serviceName">{{$t(subItem.serviceName)}}</span>
                            <b>{{subItem.quantity}}</b>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="more"
                 v-if="products.others.length > 4">
                <Icon v-if="showAll"
                      type="ios-arrow-up"
                      @click="showAll = !showAll" />
                <Icon v-else
                      type="ios-arrow-down"
                      @click="showAll = !showAll" />
            </div>
        </template>
    </div>
</template>
<script>
export default {
    name: 'cloudproduct',
    props: ['products', 'productTypeList'],
    components: {
    },
    data () {
        return {
            computes: [],
            storages: [],
            networks: [],
            showNetworks: [],
            showAll: false
        }
    },
    computed: {
        others () {
            return this.showAll ? this.products.others : this.products.others.slice(0, 4)
        }
    },
    mounted () {
    },
    created () {
    },
    watch: {
    },
    methods: {
    }
}
</script>
<style lang="less" scoped>
.more {
    text-align: center;
}
.product-pack {
    font-size: 12px;
    display: flex;
    padding: 7.5px;
    margin-bottom: 10px;
    & > li {
        width: 50%;
        margin: 0 7.5px;
        padding: 8px 15px;
        min-height: 100px;
        &.orange {
            background-color: #fff5ee;
            .tit {
                color: #ff6a01;
            }
        }
        &.pink {
            background-color: #fdf2f4;
            .tit {
                color: #f53242;
            }
        }
        .tit {
            font-weight: 600;
            line-height: 28px;
        }
        &.orange {
            background: url(../img/count.png) #fff5ee no-repeat bottom right;
        }
        &.pink {
            background: url(../img/storage.png) #fdf2f4 no-repeat bottom right;
        }
        ul {
            display: flex;
            flex-wrap: wrap;
            li {
                width: 50%;
                display: flex;
                padding: 5px 0;
                span {
                    width: 75%;
                    // text-align: center;
                }
                b {
                    display: inline-block;
                    width: 25%;
                    text-align: center;
                }
            }
        }
    }
}

ul.resource-pack {
    display: flex;
    padding: 0 10px;
    flex-wrap: wrap;
    font-size: 12px;
    overflow: hidden;
    transition: height 0.5s linear;
    li {
        flex-shrink: 0;
        width: calc(~'25% - 10px');
        height: 150px;
        padding: 0 12px;
        margin: 0 5px 10px 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #f5f6f7;
        .sub-pack {
            display: block;
            width: 100%;
            height: 100%;
            .sub-container {
                display: flex;
                justify-content: space-between;
                padding: 0 10px;
                line-height: 20px;
            }
        }
        i {
            width: 28px;
            height: 28px;
            font-size: 16px;
            border: 1px solid #e9e9e9;
            border-radius: 50%;
            text-align: center;
            line-height: 28px;
            margin-right: 12px;
            flex-shrink: 0;
        }
        span {
            width: 80%;
        }
    }
}
</style>
